module.exports = __webpack_public_path__ + "img/ABNAMRO.c865f267.jpg";